import { DataCrafterOutputVariant, DataCrafterTemplateColumn, DataCrafterTemplateStatus } from '.';
import DataCrafterInputColumn from './DataCrafterInputColumn';

export default class DataCrafterTemplate {
    id: string;
    projectId: string;
    name: string;
    createdBy: string;
    createdTime: string;
    outputPackageId: string;
    updatedBy?: string;
    updatedTime?: string;
    status: DataCrafterTemplateStatus;
    columns: DataCrafterTemplateColumn[];
    inputPackageIds?: string[];
    inputColumns?: DataCrafterInputColumn[];
    code?: string;
    plannerModelId?: string;
    coderModelId?: string;
    plannerModelName?: string;
    coderModelName?: string;
    outputVariants?: DataCrafterOutputVariant[];
    variantPickerScript?: string;
}
